import type { SessionClient } from "@phurshell/psiapp-frontend-core/domain";
import type { LoadSession } from "./Login";

/** Recarrega os dados do usuário logado e mescla na sessão (como o syncSession legado). */
export class SyncSession {
  constructor(
    private readonly sessionClient: SessionClient,
    private readonly loadSession: LoadSession,
  ) {}

  async execute(): Promise<any | null> {
    const session: any = this.sessionClient.getSession();
    if (!session?.id) return null;
    const data = await this.loadSession(session.id);
    if (data) this.sessionClient.updateSession({ ...session, ...data });
    return data;
  }
}
